import { networker as networkerInstance, parseJSON, rejectHTTPErrors } from './networker';
import { StateProvider } from './state-provider';
import { logToSplunkwithExtraDetails, pageLoadforErrorModal } from '../services/logService';
import { CatalogDataType } from '../components/MainView/MainView.container.props';
import * as Sentry from '@sentry/browser';
// Adding keep alive
// import { keepAlive, setupListeners, registerUserActivity, unregisterUserActivity} from './keepAlive';
var csrfApi = '/msapi/id';
// let callKeepAlive = true;
var promiseVar;
var CSRF_TOKEN = 'csrf-token';
var OffersService = /** @class */ (function () {
    function OffersService(networker, stateManager) {
        this.networker = networker;
        this.stateManager = stateManager;
        this.headers = [
            {
                name: 'Accept-Language',
                value: 'application/json',
            },
            {
                name: 'Content-Type',
                value: 'application/json',
            },
            {
                name: 'X-ATT-Transaction-Id',
                value: '234',
            },
        ];
    }
    OffersService.prototype.setCSRFToken = function () {
        console.log('setCsrfToekn called...........');
        return this.networker.get(csrfApi, {
            headers: this.getInitialHeaders(),
        })
            .then(this.extractHeaderDataSentry)
            .then(rejectHTTPErrors);
    };
    OffersService.prototype.fetchData = function (url, bundleType) {
        var _this = this;
        var queryParam = location.href.split('?')[1];
        if (queryParam) {
            var parmaArry = queryParam.split('&');
            for (var _i = 0, parmaArry_1 = parmaArry; _i < parmaArry_1.length; _i++) {
                var checkuuid = parmaArry_1[_i];
                if ((/uuid/i).test(checkuuid)) {
                    var uuidArry = checkuuid.split('=');
                    var uuidval = uuidArry[1];
                    // csrfApi = csrfApi + '?uuid=' + uuidval;
                }
            }
        }
        var stateCsrfToken = this.stateManager.get('appShell', CSRF_TOKEN);
        var iteration = 20;
        var counter = 0;
        if (!(stateCsrfToken && stateCsrfToken.value)) {
            var timerId_1 = setTimeout(function waitForCsrfToken(sm) {
                stateCsrfToken = sm.get('appShell', CSRF_TOKEN);
                console.log('waiting for csrf token', (new Date()).getTime(), counter, (stateCsrfToken && stateCsrfToken.value ? true : false), stateCsrfToken);
                if (!(stateCsrfToken && stateCsrfToken.value) && counter < iteration) {
                    counter++;
                    timerId_1 = setTimeout(waitForCsrfToken, 50, sm);
                }
            }, 50, this.stateManager);
        }
        else {
            console.log('found csrf token');
        }
        if (stateCsrfToken && stateCsrfToken.value) {
            return this.augmentedFetchData(url, bundleType);
        }
        else {
            return this.setCSRFToken()
                .then(function (res) {
                var token = { value: res.headers.get('X-CSRF-TOKEN') };
                if (token.value !== null) {
                    _this.stateManager.set(CSRF_TOKEN, token);
                    /* New Session Edit - Starts */
                    // Moved the code to MainView.container
                    /* New Session Edit - Ends */
                    return _this.augmentedFetchData(url, bundleType);
                }
                else {
                    return Promise.reject(res);
                }
            });
        }
    };
    OffersService.prototype.postData = function (url, data) {
        return this.networker.post(url, data, this.fetchCRT())
            .then(this.extractHeaderDataSentry)
            .then(rejectHTTPErrors)
            .then(function (res) { return parseJSON(res); });
    };
    OffersService.prototype.fetchCRT = function () {
        var options = {};
        var stateCsrfToken = this.stateManager.get('appShell', CSRF_TOKEN);
        var customHeaders = new Headers();
        if (stateCsrfToken && stateCsrfToken.value) {
            customHeaders.set('X-CSRF-TOKEN', stateCsrfToken.value);
            options = {
                headers: customHeaders,
            };
        }
        return options;
    };
    OffersService.prototype.augmentedFetchData = function (url, bundleType) {
        if (bundleType === CatalogDataType.DTVNOW || bundleType === CatalogDataType.Offers) {
            var baseRequestDTVNOW = {
                channel: 'Online',
                direcTVNow: {
                    contract: false,
                    offerType: [
                        'basepackage',
                        'standalone',
                    ],
                },
            };
            return this.networker.post(url, baseRequestDTVNOW, this.fetchCRT())
                .then(this.extractHeaderDataSentry)
                .then(rejectHTTPErrors)
                .then(function (res) { return parseJSON(res); });
        }
        return this.networker.get(url, this.fetchCRT())
            .then(this.extractHeaderDataSentry)
            .then(rejectHTTPErrors)
            .then(function (res) { return parseJSON(res); })
            .catch(function (res) {
            if (bundleType === CatalogDataType.Wireless) {
                logToSplunkwithExtraDetails(res, 
                // tslint:disable-next-line: object-literal-shorthand
                { url: url, apiName: 'IDP_CTO_LOG getOfferFromCoreUI' });
                pageLoadforErrorModal();
                return Promise.reject(res);
            }
            else {
                return Promise.reject(res);
            }
        });
    };
    OffersService.prototype.getInitialHeaders = function () {
        var defaultHeaders = new Headers();
        this.headers.forEach(function (header) {
            defaultHeaders.append(header.name, header.value);
        });
        return defaultHeaders;
    };
    OffersService.prototype.extractHeaderDataSentry = function (res) {
        var headers = res.headers;
        var headerObj = {};
        headers.forEach(function (value, key) {
            var normalizedKey = key.replace(/-/g, '_');
            headerObj[normalizedKey] = value;
        });
        Sentry.configureScope(function (scope) {
            scope.setTag('sid', headerObj.sid || 'NA');
            scope.setTag('trace_id', headerObj.idp_trace_id || 'NA');
        });
        return Promise.resolve(res);
    };
    return OffersService;
}());
export { OffersService };
export var offersService = new OffersService(networkerInstance, StateProvider.getStateManagerInstance());
//# sourceMappingURL=Offers.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/Offers.service.js
// module id = 344
// module chunks = 8